var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackChallengesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25366 4.98145C7.80316 5.12311 7.37257 5.32863 6.97564 5.59385C6.15337 6.14328 5.51248 6.9242 5.13403 7.83786C4.75558 8.75151 4.65656 9.75688 4.8495 10.7268C5.04243 11.6967 5.51865 12.5877 6.21793 13.287C6.91722 13.9863 7.80816 14.4625 8.77809 14.6554C9.74803 14.8483 10.7534 14.7493 11.6671 14.3709C12.5807 13.9924 13.3616 13.3515 13.9111 12.5293C14.1763 12.1323 14.3818 11.7017 14.5235 11.2512M10.7537 0.806119C8.89972 0.598124 7.02692 0.971403 5.39435 1.87432C3.76178 2.77724 2.45014 4.16518 1.64087 5.84613C0.8316 7.52709 0.564693 9.41799 0.877069 11.2573C1.18944 13.0966 2.06567 14.7933 3.38453 16.1128C4.70339 17.4324 6.3997 18.3094 8.23883 18.6227C10.078 18.936 11.969 18.6701 13.6504 17.8617C15.3317 17.0532 16.7203 15.7423 17.6241 14.1102C18.5278 12.4781 18.902 10.6055 18.695 8.75136M12.7539 6.75104V3.75095L15.754 0.750854V3.75095H18.7541L15.754 6.75104H12.7539ZM12.7539 6.75104L9.75342 9.75107M8.75342 9.75076C8.75342 10.016 8.85878 10.2704 9.04632 10.4579C9.23386 10.6454 9.48823 10.7508 9.75345 10.7508C10.0187 10.7508 10.273 10.6454 10.4606 10.4579C10.6481 10.2704 10.7535 10.016 10.7535 9.75076C10.7535 9.48554 10.6481 9.23118 10.4606 9.04364C10.273 8.85609 10.0187 8.75073 9.75345 8.75073C9.48823 8.75073 9.23386 8.85609 9.04632 9.04364C8.85878 9.23118 8.75342 9.48554 8.75342 9.75076Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackChallengesIcon);
export default __webpack_public_path__ + "static/media/black_challenges_icon.ed289eef174d09ccd4241a4e19ed71d5.svg";
export { ForwardRef as ReactComponent };